<sh-card>
  <api-call-gate
    class="gantry-api-call-gate"
    [apiCall]="gantryEventList"
    #gantryCallGate
  >
    <ng-template #lastSuccessfulData>
      <header slot="header" class="gantry-init-header">
        <div class="gantry-description">
          <div class="gantry-init-title">
            <sh-text id="gantry-init-element" size="header-2">
              {{ 'cts.gantry.CTStatus' | translate }}
            </sh-text>

            <div *ngIf="initStatus?.events.length === 0">
              <sh-text color="secondary">
                {{ 'cts.gantry.NoDataAvailable' | translate }}
              </sh-text>
            </div>
          </div>
          <app-cts-gantry-timezone-select
            [localDeviceOffset]="initStatus?.updatedDateOffset"
          ></app-cts-gantry-timezone-select>
        </div>
      </header>
      <div *ngIf="initStatus?.events.length > 0">
        <div class="gantry-events-container">
          <app-cts-gantry-init-event
            *ngFor="let gantryEvent of initStatus?.events; let index = index"
            [id]="'gantry-init-event-' + index"
            [gantryEvent]="gantryEvent"
            [reducedLabel]="initStatus?.events.length >= 5"
          ></app-cts-gantry-init-event>
          <div
            class="no-more-events"
            *ngIf="initStatus?.events.length < 3"
            [style.flex]="3 - initStatus?.events.length"
          >
            <sh-text color="secondary">{{
              'cts.gantry.NoMoreEvents' | translate
            }}</sh-text>
          </div>
        </div>

        <sh-divider></sh-divider>

        <div class="gantry-init-header">
          <sh-text color="secondary">
            {{ 'cts.gantry.lastUpdate' | translate }}
            {{ initStatus?.updatedDate | timeFromNow }}
          </sh-text>

          <sh-button
            id="gantry-init-details-button"
            routerLink="ct-status/events"
            color="secondary"
            label="{{ 'cts.gantry.details' | translate }}"
          ></sh-button>
        </div>
      </div>
    </ng-template>

    <ng-container *ngIf="gantryCallGate.rawError$ | async as error">
      <ng-template #error>
        <ng-container *ngIf="error.status === 400">
          <ng-container
            *ngTemplateOutlet="errorTemplate; context: { error: error }"
          ></ng-container>
        </ng-container>
      </ng-template>
    </ng-container>
  </api-call-gate>
</sh-card>

<ng-container
  *ngIf="
    modalMobileVisible &&
    ((screenLayoutService.phone$ | async) ||
      (screenLayoutService.tablet$ | async))
  "
>
  <ng-container
    *ngTemplateOutlet="
      modalDisclaimer;
      context: {
        $implicit: {
          visible:
            modalMobileVisible &&
            ((screenLayoutService.phone$ | async) ||
              (screenLayoutService.tablet$ | async)),
          id: 'modalDisclaimerMobile',
          label: 'cts.gantry.disclaimer.MobileTitle',
          message: 'cts.gantry.disclaimer.MobileViewMessage',
          onClickFn: onClickConfirmModalMobile,
          confirm: 'cts.gantry.disclaimer.mobileConfirm',
        },
      }
    "
  >
  </ng-container>
</ng-container>

<ng-template #modalDisclaimer let-data>
  <sh-modal
    sticky
    [visible]="data.visible"
    [id]="data.id"
    type="alert"
    label="{{ data.label | translate }}"
    modal-width="360px"
    modal-height="200px"
    role="alertdialog"
    aria-label="Disclaimer dialog"
  >
    <sh-text [innerHTML]="data.message | translate"></sh-text>
    <sh-button
      slot="footer"
      size="m"
      [label]="data.confirm | translate"
      (click)="data.onClickFn()"
      onkeyup="data.onClickFn()"
    ></sh-button>
  </sh-modal>
</ng-template>

<ng-template #errorTemplate let-error="error">
  <header slot="header" class="gantry-init-header">
    <sh-text id="gantry-init-element" size="header-2">
      {{ 'cts.gantry.CTStatus' | translate }}
    </sh-text>

    <div class="gantry-som-informative">
      <sh-text
        *ngIf="error.error.title === INFORMATIVE_SOM5_SOM7_ERROR_STRING"
        color="secondary"
      >
        {{ 'cts.gantry.informativeSom5som7' | translate }}
      </sh-text>
      <sh-text
        *ngIf="error.error.title === INFORMATIVE_NO_SOFTWARE_FAMILY_DETECTED"
        color="secondary"
      >
        {{ 'cts.gantry.informativeNoSoftwareFamily' | translate }}
      </sh-text>
      <sh-icon icon="warning" size="s"></sh-icon>
    </div>
  </header>
</ng-template>
